// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .alternates-button {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}[dir=rtl] .alternates-button {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n.alternates-dropdown {\n  height: 39px !important;\n}\n[dir=ltr] .alternates-dropdown {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n[dir=rtl] .alternates-dropdown {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}", ""]);
// Exports
module.exports = exports;
